import { EmailType, TEmailPreferencesForAllUsers } from "./types";
import { UserRole } from "../../user/enums/UserRole";

export const emailPreferencesConfigs: TEmailPreferencesForAllUsers = {
  [UserRole.School]: [
    {
      label: "Unread Messages",
      description: "Get email notifications for unread messages.",
      type: EmailType.Message,
      defaultValue: true,
    },
    {
      label: "Application Updates",
      description: "Updates and information about your applications.",
      type: EmailType.Application,
      defaultValue: true,
    },
    {
      label: "Program Reminders",
      description:
        "These emails may include notifications about outdated intakes, unfilled academics and more.",
      type: EmailType.Program,
      defaultValue: true,
    },
    {
      label: "Platform Updates and News",
      description: "Receive news, suggestions, tips and more.",
      type: EmailType.News,
      defaultValue: true,
    },
    {
      label: "Unsubscribe From All Email Lists",
      description: "You will still receive important emails.",
      type: EmailType.All,
      defaultValue: false,
    },
  ],
  [UserRole.ServiceProvider]: [
    {
      label: "Unread Messages",
      description: "Get email notifications for unread messages.",
      type: EmailType.Message,
      defaultValue: true,
    },
    {
      label: "Platform Updates and News",
      description: "Receive news, suggestions, tips and more.",
      type: EmailType.News,
      defaultValue: true,
    },
    {
      label: "Unsubscribe From All Email Lists",
      description: "You will still receive important emails.",
      type: EmailType.All,
      defaultValue: false,
    },
  ],
  [UserRole.Agent]: [
    {
      label: "Unread Messages",
      description: "Get email notifications for unread messages.",
      type: EmailType.Message,
      defaultValue: true,
    },
    {
      label: "Application Updates",
      description: "Updates and information about your applications.",
      type: EmailType.Application,
      defaultValue: true,
    },
    {
      label: "Platform Updates and News",
      description: "Receive news, suggestions, tips and more.",
      type: EmailType.News,
      defaultValue: true,
    },
    {
      label: "Unsubscribe From All Email Lists",
      description: "You will still receive important emails.",
      type: EmailType.All,
      defaultValue: false,
    },
  ],
  [UserRole.Parent]: [
    {
      label: "Unread Messages",
      description: "Get email notifications for unread messages.",
      type: EmailType.Message,
      defaultValue: true,
    },
    {
      label: "Application Updates",
      description: "Updates and information about your applications.",
      type: EmailType.Application,
      defaultValue: true,
    },
    {
      label: "Platform Updates and News",
      description: "Receive news, suggestions, tips and more.",
      type: EmailType.News,
      defaultValue: true,
    },
    {
      label: "Unsubscribe From All Email Lists",
      description: "You will still receive important emails.",
      type: EmailType.All,
      defaultValue: false,
    },
  ],
  [UserRole.Teacher]: [
    {
      label: "Unread Messages",
      description: "Get email notifications for unread messages.",
      type: EmailType.Message,
      defaultValue: true,
    },
    {
      label: "Platform Updates and News",
      description: "Receive news, suggestions, tips and more.",
      type: EmailType.News,
      defaultValue: true,
    },
    {
      label: "Unsubscribe From All Email Lists",
      description: "You will still receive important emails.",
      type: EmailType.All,
      defaultValue: false,
    },
  ],
  [UserRole.Student]: [
    {
      label: "Unread Messages",
      description: "Get email notifications for unread messages.",
      type: EmailType.Message,
      defaultValue: true,
    },
    {
      label: "Application Updates",
      description: "Updates and information about your applications.",
      type: EmailType.Application,
      defaultValue: true,
    },
    {
      label: "Platform Updates and News",
      description: "Receive news, suggestions, tips and more.",
      type: EmailType.News,
      defaultValue: true,
    },
    {
      label: "Unsubscribe From All Email Lists",
      description: "You will still receive important emails.",
      type: EmailType.All,
      defaultValue: false,
    },
  ],
};
